import React, { useState, useEffect } from "react";
import Layout from "../components/Layout";
import PersonaSelect from "../components/PersonaSelect";
import { api } from "../lib/api";

export default function Locais() {
  const [pid, setPid] = useState("");
  const [places, setPlaces] = useState([]);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!pid) { setPlaces([]); return; }
    api.listPlaces(pid).then(setPlaces).catch((e) => setErr(String(e.message)));
  }, [pid]);

  const gen = async () => {
    setBusy(true); setErr("");
    try { setPlaces(await api.generatePlaces(pid)); }
    catch (e) { setErr(String(e.message)); } finally { setBusy(false); }
  };

  return (
    <Layout>
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold">Locais</h1>
          <p className="text-neutral-400 text-sm mt-1">Lugares reais onde sua persona circula, com score de aderência e intenção.</p>
        </div>
        <PersonaSelect value={pid} onChange={setPid} />
      </div>
      {err && <div className="mt-4 rounded-md bg-red-600/15 text-red-400 px-4 py-2 text-sm">{err}</div>}
      {pid && (
        <button onClick={gen} disabled={busy}
          className="mt-4 rounded-md bg-red-600 hover:bg-red-500 px-4 py-2 text-sm font-medium disabled:opacity-50">
          {busy ? "Buscando locais reais…" : "Identificar locais"}
        </button>
      )}
      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-3">
        {places.map((p) => (
          <div key={p.id} className="rounded-lg border border-neutral-800 bg-neutral-900/50 p-4">
            <div className="flex justify-between">
              <span className="font-medium">{p.name}</span>
              <span className="text-xs text-neutral-400">{p.category}</span>
            </div>
            <div className="text-xs text-neutral-500 mt-1">{p.address}</div>
            <div className="mt-2 flex gap-3 text-xs">
              <span className="text-emerald-400">aderência {p.affinity_score}</span>
              <span className="text-amber-400">intenção {p.intent_score}</span>
            </div>
            {p.recommendation_reason && <div className="text-xs text-neutral-400 mt-2">{p.recommendation_reason}</div>}
          </div>
        ))}
        {pid && !places.length && <div className="text-neutral-500 text-sm">Sem locais ainda. Clique em "Identificar locais".</div>}
      </div>
    </Layout>
  );
}
